import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { KeywordsList } from '../../../_lib/components/Keywords';
import { AToZContainer, AToZToNavButton } from '../../../_lib/components/AToZContainer';
import { Facets } from '../../../types/Facets';
import ILink from '../../../types/ILink';

type KeywordsAToZ = {
  keywordsAToZ: Record<string, ILink[]>;
  facets?: Facets;
};

/**
 * As we would have a table with one column here,
 * we decided to semantically make this a list.
 * @param keywordsAToZ
 * @param facets
 * @constructor
 */
export function KeywordsAToZ({ keywordsAToZ, facets }: KeywordsAToZ) {
  const { t } = useSonTranslation('KeywordIndex');

  return (
    <AToZContainer
      facets={facets}
      characters={keywordsAToZ}
      invisibleHeadline={t('keywords.headline')}
      characterHint={t('keywords.characterHint')}
    >
      <ul className="keyword-index__table-lookalike-list">
        {Object.keys(keywordsAToZ).map(key => (
          <li className="keyword-index__table-lookalike-list-item" key={`body-${key}`}>
            <div className="keyword-index__character-button">
              <AToZToNavButton id={key} hint={t('keywords.characterHint')} />
            </div>
            <div className="keyword-index__keywords-container">
              <KeywordsList keywords={keywordsAToZ[key]} />
            </div>
          </li>
        ))}
      </ul>
    </AToZContainer>
  );
}
